import { render, staticRenderFns } from "./AutoDataList.vue?vue&type=template&id=d061f96a&"
import script from "./AutoDataList.vue?vue&type=script&lang=js&"
export * from "./AutoDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports